// extracted by mini-css-extract-plugin
export default {"container":"jI-z","disabled":"kI-z","bgBlack":"lI-z","content":"mI-z","countdown":"nI-z","topCaption":"oI-z","topHeading":"pI-z","heading":"qI-z","copy":"rI-z"};